// extracted by mini-css-extract-plugin
export default {"SalesLandingHeader":"aGmm4","SalesLandingHeader__inner":"_3NJu","SalesLandingHeader__logoWrapper":"yk3MR"};